import React from 'react';

export default function FacebookIcon({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width="10" height="20" viewBox="0 0 10 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M9.84735 6.79255H6.18977V4.59494C6.18977 3.99059 6.6962 3.49613 7.31518 3.49613H9.566V0.199707H6.75247C4.26531 0.199707 2.25082 2.16657 2.25082 4.59494V6.79255H0V10.089H2.25082V19.9782H6.18977V10.089H9.0033L9.84735 6.79255Z"></path>
    </svg>
  );
}
